import { render, staticRenderFns } from "./QuickbookSetup.vue?vue&type=template&id=f2847aee"
import script from "./QuickbookSetup.vue?vue&type=script&lang=js"
export * from "./QuickbookSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports